import { ToolbarActionState } from './types';
export function toggleActiveState(currentState) {
    return currentState === ToolbarActionState.ACTIVE
        ? ToolbarActionState.INACTIVE
        : ToolbarActionState.ACTIVE;
}
